import { getAttributeKeys, getNodeLabel, getUid } from 'Services/WeaverUtils'
import { connect } from 'react-redux'
import ColorService from 'Services/ColorService'
import { useRef, useEffect, useCallback, useState} from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import { Spin, Row, Col, Tag, List, Divider, Modal, Input } from 'antd'
import Feather from '@sysunite/react-feather'
import './SearchModal.scss'
import { setCurrentItem } from 'Actions/explore'
import { NODE } from 'Types'
import { matchSorter } from 'match-sorter'
import { getNamespaceValue } from 'Services/WeaverUtils'

SearchModal = ({ setCurrentItem, visible, onClose }) ->

  inputRef = useRef()
  [value, setValue] = useState(undefined)
  [nodes, setNodes] = useState([])
  [loading, setLoading] = useState(false)

  search = (value) ->
    setLoading(true)

    if not value? or value is ''
      results = await new Weaver.Query()
        .contains("*", value)
        .limit(20)
        .find()
    else
      results = _.unionBy(
        await new Weaver.Query()
          .contains("*", getNamespaceValue(value))
          .find(),
        await new Weaver.Query()
          .contains('id', getNamespaceValue(value))
          .find()
      , (node) -> getUid(node))

    if not value? or value is ''
      setNodes(_.sortBy(results, (node) -> getNodeLabel(node)))
    else
      setNodes(matchSorter(results, value, {
        keys: [(node) -> getNodeLabel(node)]
        threshold: matchSorter.rankings.NO_MATCH
      }))

    setLoading(false)

  debounce = useCallback(_.debounce(search, 500), [])

  useEffect(->
    if visible
      inputRef.current?.focus()
      search()
    else
      setValue('')
      setNodes([])
    undefined
  , [visible])

  useEffect(->
    if value? and visible then debounce(value)
    undefined
  , [value])

  selectItem = (node) ->
    setCurrentItem({
      type: NODE
      wvrId: getUid(node)
    })
    onClose()

  <Modal
    width='40vw'
    footer={false}
    closable={false}
    onCancel={onClose}
    visible={visible}
  >
    <Input autoFocus
      data-testid="global-search-input"
      ref={inputRef}
      style={{ borderRadius: '5px', padding: '15px' }}
      onChange={({ target: { value }}) -> setValue(value) }
      value={value}
      suffix={<Spin indicator={<LoadingOutlined style={{ visibility: if loading then 'visible' else 'hidden' }} spin />} />}
      placeholder='What are you searching for?'
      size='large' />
    <Divider />
    <List size='small'
          data-testid="global-search-modal"
          style={{ maxWidth: '40vw', maxHeight: '400px', overflow: 'auto' }}
          split={false}
          renderItem={(node) ->
            label = getNodeLabel(node)
            color = ColorService.getColorForNode(node)
            <List.Item onClick={-> selectItem(node)} className="search-item">
              <Row type="flex" gutter={16} style={{ whiteSpace: 'nowrap', flexWrap: 'nowrap', padding: '0px 10px', width: '100%' }}>
                <Col style={{ flex: 1 }}>
                  <Feather width="1em" height="1em" type="circle" style={{ fill: color, color }} /> { label }
                </Col>
              </Row>
            </List.Item>
          }
          dataSource={nodes} />
  </Modal>

export default connect(undefined, { setCurrentItem })(SearchModal)
